import React, { Fragment, useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import propTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'assets/css/style.css';
import 'assets/css/App.css';
import 'assets/css/toastify.css';
import { connect } from 'react-redux';
import Routers from 'routers/routers';
import { bindActionCreators,loginReducer } from 'redux';
import { showHideToast } from 'services/redux/sales/appNotifications/action';
import AppNotifications from 'components/sales/appNotifications/appNotifications';

const App = ({ toggleToast, toastMsg, ...rest }) => {
  const [isConnected, setIsConnected] = useState(false);
  const [isAuthAnk,setIsAuth] = useState(false);
  useEffect(() => {
    const handleConnection = (event) => {
      if (event.type === 'offline') {
        setIsConnected(true);
        toggleToast(true, '');
      } else {
        setIsConnected(false);
        toggleToast(false, '');
      }
    };
    window.addEventListener('online', handleConnection);
    window.addEventListener('offline', handleConnection);
    return () => {
      window.removeEventListener('online', handleConnection);
      window.removeEventListener('offline', handleConnection);
    };
  }, [isConnected, toggleToast]);

  

  const closeToast = (modal, message) => {
    toggleToast(modal, message);
  };

  return (
    <div>
       {/* authenticated: localStorage.getItem('authenticated')?JSON.parse(localStorage.getItem('authenticated'):false, */}
    <Fragment>
      <AppNotifications
        closeToast={closeToast}
        visible={isConnected || toastMsg?.isToast}
        message={toastMsg?.toastMessage}
      />
      
       <Routers {...rest} />
    
    </Fragment>
    <ToastContainer position="top-center" />
    </div>
  );
};

App.propTypes = {
  authenticated: propTypes.bool.isRequired,
  checked: propTypes.bool.isRequired,
};


const mapStateToProps = (state) => {
      var authenticatedV = false;
      if(localStorage.getItem('authenticated')){
        authenticatedV = JSON.parse(localStorage.getItem('authenticated'));
      }else{
      authenticatedV = false;
      }
    return {
      // checked: true,
      checked: state.session.checked,
      authenticated: authenticatedV,
      toastMsg: state.toastReducer,
    };
  
  
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      toggleToast: showHideToast,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(App);
